import {useContext} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCircleWarningOutline from '@adv-mt/mt-svg-icons/lib/CircleWarningOutline.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

const N_ITEMS_REASONS = 4

const HelpText = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const imageUrl = `${URL_STATICS_IMAGES}pictograms/Warning.svg`

  return (
    <div className="mt-TransactionSellerCancelledContractModal-helpText">
      <img src={imageUrl} height={48} width={58} alt={i18n.t('VEHICLE_TRANSACTION.CANCELLED_CONTRACT.HELP_TEXT')} />
      <div className="mt-TransactionSellerCancelledContractModal-helpTextInfo">
        {i18n.t('VEHICLE_TRANSACTION.CANCELLED_CONTRACT.HELP_TEXT')}
      </div>
    </div>
  )
}

export const SellerCancelledContractsTransactionModal = () => {
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')

  const imageUrl = `${urlStaticsImages}illustrations/error-500.svg`

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionSellerCancelledContractModal-modalContainer">
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionSellerCancelledContractModal-modalChildren">
                  <HelpText />
                  <strong>{i18n.t('VEHICLE_TRANSACTION.CANCELLED_CONTRACT.MAIN_TEXT')}</strong>
                  <div className="mt-TransactionSellerCancelledContractModal-listItems">
                    {Array.from(Array(N_ITEMS_REASONS).keys()).map(i => (
                      <div className="mt-TransactionSellerCancelledContractModal-listItem">
                        <div className="mt-TransactionSellerCancelledContractModal-listItemIcon">
                          <IconCircleWarningOutline size="medium" />
                        </div>
                        <span>{i18n.t(`VEHICLE_TRANSACTION.CANCELLED_CONTRACT.REASON_${i}`)}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ),
              headerImage: (
                <div className="mt-TransactionModal-contentHeaderImageWrapper">
                  <AtomImage
                    alt={i18n.t('VEHICLE_TRANSACTION.CANCELLED_CONTRACT.TITLE')}
                    className="mt-TransactionModal-contentHeaderImage"
                    src={imageUrl}
                  />
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.CANCELLED_CONTRACT.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
